import { Directive, ElementRef, HostListener, Optional, Self } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MainService } from 'src/app/services/main-service.service';

@Directive({
  selector: '[appAlphabetsOnly]',
  standalone: true
})
export class AlphabetsOnlyDirective {

  constructor(
    private _ef: ElementRef,
    private _mainService: MainService,
    @Optional() @Self() private ngModel: NgModel
  ) { }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initialValue = this._ef.nativeElement.value;
    this._ef.nativeElement.value = initialValue.replace(/[^A-Za-zÀ-ÿ\- ]/g, '');
    if ( initialValue !== this._ef.nativeElement.value) {
      // this._ef.nativeElement.value = initialValue;
      // (event.target as HTMLInputElement).value = initialValue;
      // if (this.ngModel) {
      //   this.ngModel.control.setValue(initialValue);
      // }
      event.stopPropagation();
      return;
    }
  }

}
